import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LicenseManager } from 'ag-grid-enterprise';

import { createAppModule } from './app/app.module';
import {
  APPLICATION_CONFIG,
  ApplicationConfig,
} from './app/models/application-config';
import { environment } from './environments/environment';
import { sentryInit } from './sentry-init';

if (environment.production) {
  enableProdMode();
}

fetch('/assets/config.json')
  .then((config) => config.json())
  .then((config: ApplicationConfig) => {
    //must be initialized outside angular context
    LicenseManager.setLicenseKey(config.agGridLicense);

    sentryInit(config.sentryDsn);
    platformBrowserDynamic([
      { provide: APPLICATION_CONFIG, useValue: config },
    ]).bootstrapModule(createAppModule(config));
  })
  .catch((err) => {
    console.error(err);
  });
